import { SolutionDetailTemplate } from '../shared/SolutionDetailTemplate';

export function ComputerVisionPage() {
  const keyFeatures = [
    "Real-time image and video processing with millisecond response times",
    "Advanced defect detection with 99.8% accuracy across manufacturing lines",
    "Automated object recognition and classification for quality control",
    "Seamless integration with existing production and surveillance systems",
    "Scalable cloud-based processing for high-volume visual data analysis",
    "Customizable AI models trained on industry-specific visual patterns"
  ];

  const benefits = [
    "Reduce quality inspection time by up to 50% while maintaining accuracy",
    "Eliminate human error in visual inspection processes",
    "Achieve consistent quality standards across all production shifts",
    "Lower operational costs through automated visual monitoring",
    "Scale visual inspection capabilities without adding personnel",
    "Generate actionable insights from visual data analytics"
  ];

  const useCases = [
    "Manufacturing quality control and defect detection",
    "Automated security surveillance and threat identification",
    "Medical imaging analysis and diagnostic support",
    "Retail inventory management and product recognition",
    "Infrastructure monitoring and maintenance assessment",
    "Agricultural crop monitoring and yield optimization"
  ];

  const relatedTools = [
    {
      name: "Predictive Maintenance",
      description: "AI-powered equipment monitoring",
      href: "/solutions/predictive-maintenance"
    },
    {
      name: "Workplace Safety Compliance",
      description: "Safety monitoring and compliance tracking",
      href: "/solutions/workplace-safety-compliance"
    }
  ];

  const industries = [
    "Manufacturing & Production",
    "Healthcare & Medical Imaging",
    "Security & Surveillance",
    "Retail & E-commerce",
    "Transportation & Logistics",
    "Agriculture & Food Processing"
  ];

  return (
    <SolutionDetailTemplate
      title="Computer Vision"
      description="Advanced computer vision solutions that enable machines to see, understand, and act on visual data with superhuman accuracy and speed for automated quality control and inspection."
      category="AI Solutions"
      categoryColor="#00CFFF"
      keyFeatures={keyFeatures}
      benefits={benefits}
      useCases={useCases}
      relatedTools={relatedTools}
      industries={industries}
    />
  );
}